import { EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { roundNum } from '../../services/utils.service';


export const INPUT_DECIMAL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputDecimalComponent),
  multi: true,
};

@Component({
  selector: 'app-input-decimal',
  templateUrl: './input-decimal.component.html',
  styleUrls: ['./input-decimal.component.css'],
  providers: [INPUT_DECIMAL_VALUE_ACCESSOR],
})
export class InputDecimalComponent implements ControlValueAccessor {
  @ViewChild('input') input!: ElementRef;
  @Input('decimals') decimals: number = 0;
  @Input('initValue') initValue: number = 0;
  @Input('placeholder') placeholder: string = "";
  @Input('readonly') readonly: boolean = false;
  @Input('material') material: boolean = true;
  @Output() updated: EventEmitter<void> = new EventEmitter<void>();

  onChange = (value: any) => { /*console.log(value)*/ };
  onTouched = () => { };

  decimalSeparator = (1.1).toLocaleString().substring(1, 2);
  value: number = 0;
  results: any;

  constructor() { }

  ngAfterViewInit() {
    if (this.decimals < 0) this.decimals = 0;
    if (this.decimals > 4) this.decimals = 4;
    if (this.input) {
      this.input.nativeElement.value = this.initValue;
      this.formatInput();
    }
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  registerOnChange(fn: any) {
    //console.log('register onChange');
    this.onChange = fn;
  }

  writeValue(value: any) {
  }

  onInputChange() {
    this.formatInput();
    let newValue = this.input.nativeElement.value
    newValue = roundNum(newValue.replace(/,/g, '.'), this.decimals);
    this.value = newValue;
    this.onChange(newValue); // Notifica al componente padre del nuevo valor
    this.updated.emit(newValue);
  }

  formatInput() {
    let inputValue: string = this.input.nativeElement.value;

    if (inputValue.startsWith(",") || inputValue.startsWith(".")) inputValue = "0" + inputValue;

    // Reemplaza todas las comas por puntos, si hay más de un punto, elimina los excesos
    inputValue = inputValue.replace(/,/g, '.');
    const dotCount = inputValue.split('.').length - 1;
    if (dotCount > 1) {
      inputValue = inputValue.replace(/\./g, (match, offset) => offset === inputValue.lastIndexOf('.') ? '.' : '');
    }

    // Elimina caracteres no numéricos y no puntos/comas
    inputValue = inputValue.replace(/[^\d.,]/g, '');

    // Cambia el separador al local
    inputValue = inputValue.replace(/[\.,]/g, this.decimalSeparator);

    // Si el último caracter es una coma o un punto y hay más de un dígito, 
    // mueve ese caracter al final
    if ((inputValue.endsWith(',') || inputValue.endsWith('.')) && inputValue.length > 1) {
      inputValue = inputValue.slice(0, -1) + inputValue.slice(-1);
    }

    // Limita la cantidad de decimales
    const decimalIndex = inputValue.indexOf(this.decimalSeparator);
    if (decimalIndex !== -1 && inputValue.length - decimalIndex - 1 > this.decimals) {
      inputValue = inputValue.substring(0, decimalIndex + this.decimals + 1);
    }

    this.input.nativeElement.value = inputValue;
  }
}


